module.exports = __webpack_public_path__ + "img/vdm150.a6d73406.png";